/* Product page behavior: gallery, qty stepper, variant sync, sticky bar and
   server-rendered recommendations. Details panels are native <details>, so
   they need no script. */
(function () {
  /* gift card recipient: fields only submit when the toggle is on; Shopify needs the
     buyer's timezone offset to send on the chosen day */
  var gift = document.querySelector('[data-gift-recipient]');
  if (gift) {
    var toggle = gift.querySelector('[data-gift-toggle]');
    var fields = gift.querySelector('[data-gift-fields]');
    var offset = gift.querySelector('[data-gift-offset]');
    var email = gift.querySelector('[data-gift-email]');
    var sendOn = gift.querySelector('[data-gift-send-on]');
    var sync = function () {
      var on = toggle.checked;
      fields.hidden = !on;
      Array.prototype.forEach.call(fields.querySelectorAll('input, textarea'), function (el) { el.disabled = !on; });
      if (email) email.required = on;
      if (offset) { offset.disabled = !on; offset.value = new Date().getTimezoneOffset().toString(); }
    };
    if (sendOn) {
      var today = new Date(); today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
      sendOn.min = today.toISOString().slice(0, 10);
      var limit = new Date(today); limit.setDate(limit.getDate() + 90); // Shopify schedules up to 90 days ahead
      sendOn.max = limit.toISOString().slice(0, 10);
    }
    toggle.addEventListener('change', sync);
    sync();
  }

  var form = document.getElementById('ProductForm');
  var jsonEl = document.querySelector('[data-product-json]');

  // ---- qty stepper (main form + sticky bar share the form's quantity input)
  function qtyInput() {
    return form ? form.querySelector('input[name="quantity"]') : null;
  }
  function setQty(val) {
    var input = qtyInput();
    if (!input) return;
    input.value = Math.max(1, val || 1);
    var display = document.querySelector('[data-sticky-qty]');
    if (display) display.textContent = input.value;
  }
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus], [data-sticky-minus]');
    var plus = e.target.closest('[data-qty-plus], [data-sticky-plus]');
    if (!minus && !plus) return;
    var input = qtyInput();
    if (!input) return;
    setQty(parseInt(input.value || '1', 10) + (plus ? 1 : -1));
  });
  if (form) {
    var qi = qtyInput();
    if (qi) qi.addEventListener('input', function () { setQty(parseInt(qi.value || '1', 10)); });
  }

  // ---- gallery: thumbs switch the active slide on desktop; on phones the
  // track scrolls and the dots follow it
  (function () {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.lum-pdp__slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dots] span'));
    if (slides.length < 2) return;

    function mobile() { return window.matchMedia('(max-width: 1023px)').matches; }
    function activate(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-thumb'), 10);
        if (mobile()) {
          slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        } else {
          activate(i);
        }
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!mobile() || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        ticking = false;
      });
    }, { passive: true });
  })();

  // ---- sticky Add to Cart bar — appears when the main button leaves the viewport
  (function () {
    var bar = document.getElementById('StickyAtcBar');
    var target = form ? form.querySelector('button[type="submit"]') : document.querySelector('.lum-pdp__gate a');
    if (!bar || !target) return;
    function headerHeight() {
      var nav = document.querySelector('header, .sticky');
      return (nav && nav.offsetHeight) || 0;
    }
    var ticking = false;
    function check() {
      var rect = target.getBoundingClientRect();
      // show once the button has scrolled up out of view; not while it is still below the fold
      var passed = rect.bottom < headerHeight() + 4;
      bar.classList.toggle('is-shown', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      var chat = document.querySelector('shopify-chat');
      if (chat) {
        chat.style.transition = 'transform 0.3s ease-out';
        chat.style.transform = passed ? 'translateY(-' + (bar.offsetHeight + 8) + 'px)' : '';
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { check(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  })();

  // ---- variant sync
  if (form && jsonEl) {
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { product = null; }
    if (product) {
      var selects = form.querySelectorAll('[data-option-index]');
      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = document.getElementById('ProductPrice');
      var stockEl = document.getElementById('ProductStock');
      var button = form.querySelector('button[type="submit"]');
      var label = form.querySelector('[data-add-label]');
      function money(cents) { return '$' + (cents / 100).toFixed(2); }
      function sync() {
        var chosen = [];
        selects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
        var v = product.variants.find(function (x) {
          return x.options.every(function (opt, i) { return opt === chosen[i]; });
        });
        if (!v) { if (button) { button.disabled = true; if (label) label.textContent = 'Unavailable'; } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (stockEl) {
          stockEl.classList.toggle('is-in', v.available);
          stockEl.classList.toggle('is-out', !v.available);
          stockEl.lastChild.textContent = v.available ? 'In stock online' : 'Out of stock online';
        }
        if (button) button.disabled = !v.available;
        if (label) label.textContent = v.available ? 'Add to cart' : 'Out of stock';
        var stickyPrice = document.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        var stickyVariant = document.querySelector('[data-sticky-variant]');
        if (stickyVariant && v.title !== 'Default Title') stickyVariant.textContent = v.title;
        var stickyAdd = document.querySelector('[data-sticky-add]');
        if (stickyAdd) stickyAdd.disabled = !v.available;
      }
      selects.forEach(function (s) { s.addEventListener('change', sync); });
    }
  }

  // ---- recommendations: the product-recommendations section rendered by
  // Shopify with the site's own product card, dropped in below the details
  var reco = document.querySelector('[data-recommendations]');
  if (reco && reco.dataset.url) {
    fetch(reco.dataset.url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');
        if (!section || !section.querySelector('.lum-rail__item')) return;
        reco.innerHTML = section.innerHTML;
        reco.hidden = false;
      })
      .catch(function () {});
  }
})();
